import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { spotlight, SpotlightProvider } from "@mantine/spotlight";
import { useMount } from "react-use";
import { filterActions } from "@mantine/spotlight/esm/Spotlight/filter-actions/filter-actions";
export function AppSpotlight({ children }) {
    const [query, setQuery] = useState('');
    const [spotlightActions, setSpotlightActions] = useState([]);
    function filter(query, arr) {
        const defaultResult = filterActions(query, arr);
        const specialItems = arr.filter(el => el.special);
        const specialResult = specialItems.map(el => {
            if (el.match) {
                const matchResult = el.match(query);
                if (matchResult)
                    return Object.assign(Object.assign({}, el), { onTrigger: matchResult.onTrigger || el.onTrigger });
            }
            return false;
        }).filter(Boolean);
        return [...specialResult, ...defaultResult];
    }
    return (_jsx(SpotlightProvider, Object.assign({ actions: spotlightActions, onActionsChange: arr => {
            return setSpotlightActions(prev => [...prev, ...arr]);
        }, shortcut: ['`', 'ctrl+ё', 'ctrl+`'], query: query, onQueryChange: setQuery, filter: filter }, { children: children })));
}
export function useSpotlightActions(actions) {
    return useMount(() => {
        spotlight.registerActions(actions);
        //return () => spotlight.removeActions(actions.map(el => el.id));
    });
}
